import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { languageByCountryCode } from '@/config/constants';
const detection = {
    // order and from where user language should be detected
    order: ['cookie', 'localStorage', 'navigator'],
    // keys or params to lookup language from
    lookupCookie: 'moveo_web_client_language',
    lookupLocalStorage: 'moveo_web_client_language',
    // cache user language on
    caches: ['localStorage', 'cookie'],
};
i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(Backend)
    .init({
    supportedLngs: Object.keys(languageByCountryCode),
    load: 'all',
    backend: {
        loadPath: '/public/locales/{{lng}}.json',
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
    detection,
});
// eslint-disable-next-line import/no-default-export
export default i18next;
